import { render } from "./InfoTool.vue?vue&type=template&id=faac4290&scoped=true"
import script from "./InfoTool.vue?vue&type=script&lang=ts"
export * from "./InfoTool.vue?vue&type=script&lang=ts"

import "./InfoTool.vue?vue&type=style&index=0&id=faac4290&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-faac4290"

export default script